import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  call_type: [
    {...makeRule('请选择沟通类型', 'integer')},
  ],
  communicate_detail: [
    {...makeRule('请选择记录详情', 'integer')},
  ],
  record_detail: [
    {...makeRule('请选择沟通详情', 'string')},
  ],
  communicate_type: [
    {...makeRule('请选择沟通方式', 'integer')},
  ],

}

export let searchMasRules = {
  type: [
    {...makeRule('请选择群发消息', 'integer')},
  ],
  title: [
    {...makeRule('请输入消息标题', 'string')},
    {...makeRule('长度在1到30个字符'), min: 1, max: 30},

  ],
  content: [
    {...makeRule('请输入消息内容', 'string')},
    {...makeRule('长度在1到300个字符'), min: 1, max: 300},
  ],
}

export let formRules = {
  cellphone: [
    {...makeRule('请输入手机号', 'string')},
  ],
}

export let freezeFormRules = {
  freeze_status: [
    {...makeRule('请选择封号状态', 'integer')},
  ],
  freeze_reason: [
    {...makeRule('请选择封号原因', 'integer')},
  ],
  freeze_reason_desc: [
    {...makeRule('请输入封号原因')},
  ]

}

export let newUserConfigRules = {
  condition_type: [
    {...makeRule('请选择条件类型', 'string')},
  ]
}

export let newbieMissionConfigRules = {
  'watch_tutorial_video.video_url': [
    { required: true, message: '请选择教程视频', trigger: 'change' }
  ],
  'watch_tutorial_video.img_url': [
    { required: true, message: '请上传教程视频封面', trigger: 'change' }
  ],
  'finish_newbie_task.task_id': [
    { required: true, message: '请选择一个新手任务', trigger: 'change' }
  ]
}



// WEBPACK FOOTER //
// ./src/views/users/users.rules.js